import styled from 'styled-components';

import Grid from '@material-ui/core/Grid';

import * as theme from '../../../../theme';

export const IconContainer = styled(Grid)`
  color: ${theme.statusColors.warning};
`;
